import { createContext, useContext, useState, useEffect, useMemo } from "react";
import secureLocalStorage from 'react-secure-storage';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

export const BookContext = createContext();

export function BookProvider({ children }) {
	// useMemo로 캐싱하지 않으면 value가 바뀔 때마다 state를 사용하는 모든 컴포넌트가 매번 리렌더링됨
	const [userData, setUserData] = useState(() => {
		// localStorage에서 초기 데이터 로드
		const savedData = secureLocalStorage.getItem('myAppData');
		//("context init myAppData : " + savedData)
		return savedData ? JSON.parse(savedData) : { };
	});

	const [saveTime, setSaveTime] = useState(0);


	useEffect(() => {
		// data 상태가 변경될 때마다 localStorage에 저장
		//("context useEffect change userData")
		secureLocalStorage.setItem('myAppData', JSON.stringify(userData));
	}, [userData]);

	const actions = useMemo(function memoActions() {
		return {
			extendTime(userInfoData) {
				if (!userInfoData || !userInfoData.saveTime) {
					return;
				}
				var userInfo = userInfoData;

				//("Call action extentime :" + JSON.stringify(userInfoData))
				var lastTime = dayjs(userInfo.saveTime);
				if (lastTime.add(30, 'minute') > dayjs()) {
					var newSaveTime = dayjs().valueOf();
					userInfo.saveTime = newSaveTime;
					setUserData(userInfo);
				}


			}
			
		};
	}, []);

	const updateUserInfo = (newData) => {
		var userInfo = newData;
		var newSaveTime = dayjs().valueOf();
		userInfo.saveTime = newSaveTime;
		//("context updateUserInfo newSaveTime : " + newSaveTime)

		

		setUserData(userInfo);
		//				setSaveTime(newSaveTime);
//		console.log("context updateUserInfo userData : " + JSON.stringify(userData))

	}


	const isLogin = () => {

		//('context isLogin userData :' + JSON.stringify(userData))

		if (userData && userData.userEmail && userData.saveTime) {

			var lastTime = dayjs(userData.saveTime);
			//("context isLogin saveTime :" + userData.saveTime)
			//("context isLogin lastTime :" + lastTime.format('YYYY-MM-DDTHH:mm:ss'))
			//("context isLogin now :" + dayjs().format('YYYY-MM-DDTHH:mm:ss'))
			if (lastTime.add(30, 'minute') > dayjs()) {
				//('context isLogin 로그인 상태임 ');
				return true;
			}
		}
		//('context isLogin 로그아웃 상태임 ');
		return false;
	}

	const setLogOut = () => {
		setUserData(undefined);


	}



	const value = useMemo(() => ({ userData, isLogin, setLogOut, updateUserInfo, actions }), [userData, isLogin, setLogOut, updateUserInfo, actions]);
//	const value = { userData, actions };
	return <BookContext.Provider value={value}>{children}</BookContext.Provider>
}


export const useBookContext = () => useContext(BookContext)